import { combineReducers } from '@reduxjs/toolkit';

import api from '../api/api';

// reducers
// GENERAL
import dictionariesReducer from './dictionaries/slice';
import problemGeneralTransactionReducer from '../hoc/customers/store/slices/gl-transaction';
import problemInternalTransactionReducer from '../hoc/customers/store/slices/internal-transaction';
import problemIncomingTransactionReducer from '../hoc/customers/store/slices/incoming-transaction';
import problemOutgoingTransactionReducer from '../hoc/customers/store/slices/outgoing-transaction';
import problemExchangeTransactionReducer from '../hoc/customers/store/slices/exchange-transaction';
import problemNostroTransactionReducer from '../hoc/customers/store/slices/nostro-transaction';
import customerStatementsReducer from '../hoc/customers/store/slices/statements';
import customerAccountsTransactionsReducer from '../hoc/customers/store/slices/accounts-statements';
import customerStatisticReducer from '../hoc/customers/store/slices/statistic';
import customerCardsReducer from '../hoc/customers/store/slices/cards';
import customerDocumentsReducer from '../hoc/customers/store/slices/documents/documents';
import customerDocumentCreateReducer from '../hoc/customers/store/slices/documents/create';
import customerTariffsReducer from '../hoc/customers/store/slices/tariffs/tariff';
import customerFeeFormReducer from '../hoc/customers/store/slices/tariffs/form';
import customerTransactionFromFeeReducer from '../hoc/customers/store/slices/tariffs/transaction-from-fee';
import customersGeneralTransactionReducer from '../hoc/customers/store/slices/transactions/gl';
import customerTopUpPanelReducer from '../hoc/customers/store/slices/top-up';
import customerBeneficiariesReducer from '../hoc/customers/store/slices/beneficiaries/beneficiaries';
import customersExternalAccountsReducer from '../hoc/customers/store/slices/external-accounts';
import customersNotificationsCetner from '../hoc/notification-center/store/slices';

// INDIVIDUAL
import individualCustomersListReducer from '../hoc/individual/store/slices/list';
import individualCustomerCreateReducer from '../hoc/individual/store/slices/create';
import individualCustomerGeneralInfoReducer from '../hoc/individual/store/slices/general-info';
import individualCustomerOverviewReducer from '../hoc/individual/store/slices/overview/overview';
import individualCustomerAccountsReducer from '../hoc/individual/store/slices/accounts/accounts';
import individualCustomerAmlReducer from '../hoc/individual/store/slices/aml/aml';
import individualCustomerCardsReducer from '../hoc/individual/store/slices/cards/cards';
import individualCustomerDevicesReducer from '../hoc/individual/store/slices/devices';
import individualCustomerSecurityReducer from '../hoc/individual/store/slices/security';

// CORPORATE
import corporateCustomersListReducer from '../hoc/corporate/store/slices/list';
import corporateCustomerGeneralInfoReducer from '../hoc/corporate/store/slices/general-info';
import corporateCustomerOverviewReducer from '../hoc/corporate/store/slices/overview/overview';
import corporateCustomerAccountsReducer from '../hoc/corporate/store/slices/accounts/accounts';
import corporateCustomerAmlReducer from '../hoc/corporate/store/slices/aml/aml';
import corporateCustomerCardsReducer from '../hoc/corporate/store/slices/cards/cards';
import corporateCustomerCreateReducer from '../hoc/corporate/store/slices/create';

// NEW APPLICATION
import newApplicationListReducer from '../hoc/new-application/store/slices';
import newApplicationIndividualInfoReducer from '../hoc/new-application/individual/store/slices';
import newApplicationCorporateInfoReducer from '../hoc/new-application/corporate/store/slices';
import newApplicationMainRepresentativeReducer from '../hoc/new-application/main-representative/store/slices';

// middlewares
import customerMiddleware from '../hoc/customers/store/middlewares/customers';
import individualCustomerMiddleware from '../hoc/individual/store/middlewares/individual';
import corporateCustomerMiddleware from '../hoc/corporate/store/middlewares/corporate';

export const customersReducers = {
  customersApi: api.reducer,
  customersDictionaries: dictionariesReducer,
  customersNotificationsCenter: customersNotificationsCetner,
  customersProblemTransactions: combineReducers({
    gl: problemGeneralTransactionReducer,
    internal: problemInternalTransactionReducer,
    incoming: problemIncomingTransactionReducer,
    outgoing: problemOutgoingTransactionReducer,
    exchange: problemExchangeTransactionReducer,
    nostro: problemNostroTransactionReducer,
  }),
  statistic: customerStatisticReducer,
  customerAccountsStatements: customerAccountsTransactionsReducer,
  customersStatmenetsTransactions: combineReducers({
    gl: customersGeneralTransactionReducer,
  }),
  customerBeneficiaries: customerBeneficiariesReducer,
  customerStatements: customerStatementsReducer,
  customerCards: customerCardsReducer,
  customerDocuments: customerDocumentsReducer,
  customerDocumentCreate: customerDocumentCreateReducer,
  customerTariffs: customerTariffsReducer,
  customerFeeForm: customerFeeFormReducer,
  customerTransactionFromFee: customerTransactionFromFeeReducer,
  customersExternalAccounts: customersExternalAccountsReducer,
  topUpPanel: customerTopUpPanelReducer,
  individualCustomers: combineReducers({
    list: individualCustomersListReducer,
    create: individualCustomerCreateReducer,
    info: combineReducers({
      general: individualCustomerGeneralInfoReducer,
      overview: individualCustomerOverviewReducer,
      accounts: individualCustomerAccountsReducer,
      aml: individualCustomerAmlReducer,
      cards: individualCustomerCardsReducer,
      devices: individualCustomerDevicesReducer,
      security: individualCustomerSecurityReducer,
    }),
  }),
  corporateCustomers: combineReducers({
    list: corporateCustomersListReducer,
    create: corporateCustomerCreateReducer,
    info: combineReducers({
      general: corporateCustomerGeneralInfoReducer,
      overview: corporateCustomerOverviewReducer,
      accounts: corporateCustomerAccountsReducer,
      aml: corporateCustomerAmlReducer,
      cards: corporateCustomerCardsReducer,
    }),
  }),
  newApplications: combineReducers({
    individualInfo: newApplicationIndividualInfoReducer,
    corporateInfo: newApplicationCorporateInfoReducer,
    mainRepresentative: newApplicationMainRepresentativeReducer,
    list: newApplicationListReducer,
  }),
};

export const customersApi = [
  api.middleware,
  customerMiddleware.middleware,
  individualCustomerMiddleware.middleware,
  corporateCustomerMiddleware.middleware,
];
